import React, { FC } from "react"
import { FlatButton } from "../FlatButton/FlatButton"

interface ActionButtonProps {
    text: string
    action?: (() => Promise<void>) | (() => void)
    buttonText?: string
    disabled?: boolean
    hideButton?: boolean
}

export const ActionButton: FC<ActionButtonProps> = ({
    text,
    action,
    buttonText = "",
    disabled = false,
    hideButton = false
}) => (
    <div className="flex absolute left-0 top-0 h-full w-full p-3 items-center justify-center text-center flex-col">
        <p className={`text-smoke-850 ${!hideButton ? "mb-4" : ""}`}>{text}</p>
        {!hideButton && (
            <FlatButton
                onClick={action}
                className="bg-transparent"
                style={{ width: "max-content" }}
                disabled={disabled}
            >
                {buttonText}
            </FlatButton>
        )}
    </div>
)
